import $ from 'jquery';

Drupal.behaviors.accordion = {
  attach() {
    const accHD = document.querySelectorAll('.accrodion-item-inner .ac-title');

    function toggleItem(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const itemClass = this.parentNode.className;
      const accItem = $(this).closest('.accordion').find('.accrodion-item-inner');
      for (let i = 0; i < accItem.length; i += 1) {
        accItem[i].className = 'accrodion-item-inner close';
      }
      this.parentNode.className = 'accrodion-item-inner open';
      if (itemClass === 'accrodion-item-inner open') {
        this.parentNode.className = 'accrodion-item-inner close';
      }
    }

    for (let i = 0; i < accHD.length; i += 1) {
      accHD[i].addEventListener('click', toggleItem, false);
    }

    $(document).on('click', '.accrodion-item-inner .ac-title', () => {
      if (
        $(this)
          .closest('.accrodion-item-inner')
          .hasClass('open')
      ) {
        $(this)
          .find('.ac-accessibilty-txt')
          .text('click to close accordion');
      } else {
        $(this)
          .find('.ac-accessibilty-txt')
          .text('click to open accordion');
      }
    });
  },
};
